import { Button } from '@/common/ui/Form/Button'
import { Input } from '@/common/ui/Form/Input'
import type { InputType } from '@/common/ui/Form/Input'
import { Icon } from '@/common/ui/Icon'
import { forwardRef, useCallback, useState, type KeyboardEvent } from 'react'

export type InputPasswordProps = Omit<InputType, 'type' | 'afterIcon' | 'afterSlot'>

export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
    ({ size = 'md', disabled, className, ...props }, ref) => {
        const [showPassword, setShowPassword] = useState(false)

        const handleToggle = useCallback(() => {
            setShowPassword(prev => !prev)
        }, [])

        const handleToggleKeyDown = useCallback(
            (event: KeyboardEvent<HTMLButtonElement>) => {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return
                }

                event.preventDefault()
                handleToggle()
            },
            [handleToggle]
        )

        const inputType = showPassword ? 'text' : 'password'

        return (
            <Input
                ref={ref}
                type={inputType}
                size={size}
                disabled={disabled}
                className={className}
                afterSlot={
                    !disabled && (
                        <Button
                            type='button'
                            variant='ghost'
                            emphasis='accent-secondary'
                            size={size}
                            disabled={disabled}
                            onClick={handleToggle}
                            onKeyDown={handleToggleKeyDown}
                            className='shrink-0'
                            aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                        >
                            <Icon name={showPassword ? 'eye-slash' : 'eye'} size={size} />
                        </Button>
                    )
                }
                {...props}
            />
        )
    }
)

InputPassword.displayName = 'InputPassword'
